module.exports = __webpack_public_path__ + "static/media/06.d119dbb2.png";